<div
  class="section-label"
  [ngStyle]="{
    'margin-top': mt,
    'margin-bottom': mb,
    'font-weight': weight,
    '--desktop-font-size': size,
    '--mobile-font-size': mobileSize || size
  }"
>
  <ng-content></ng-content>
</div>
